import searchFields from '@/config/searchRules';

export default {
  methods: {
    _checkErrorCode(searchValue, searchRules) {
      for (const [key, value] of Object.entries(searchRules)) {
        if (value(searchValue)) {
          return key;
        }
      }
      return '';
      // return error code and message
    },
    execSearchForRules(field = '', value = '', condition = '') {
      let errorCode;
      if (searchFields[field]) {
        //if condition
        if (condition && searchFields[field]['typeCondition'].includes(condition)) {
          errorCode = this._checkErrorCode(value, searchFields[field]['searchRules']);
        }
      }
      if (errorCode) {
        this.$modal.open({
          rootId: 'app',
          type: 'alert',
          title: this.$t('title.notice'),
          message: this.$t(`errorCode.${errorCode}`),
          action: () => {
            this.resetSearchField();
          }
        });
      } else this.execSearch();
    },
    resetSearchField() {
      //Todo
    },
    execSearch() {
      //Todo
    }
  }
};
